import React from 'react';
import { motion } from 'framer-motion';
import { Container } from '../ui/Container';
import { FileText, CheckSquare, BarChart3, ClipboardList, Layers, ArrowRight } from 'lucide-react';
export function SystemsGrid() {
  const systems = [{
    name: 'Document Control',
    icon: FileText,
    desc: 'Automated transmittals, RFIs, and version control that actually work.'
  }, {
    name: 'Approvals & Workflows',
    icon: CheckSquare,
    desc: 'No more email chains. Clear approval paths with automatic escalations.'
  }, {
    name: 'Project Reporting',
    icon: BarChart3,
    desc: 'Real-time dashboards that pull data automatically. No manual compilation.'
  }, {
    name: 'QA & ITPs',
    icon: ClipboardList,
    desc: 'Digital inspection forms that sync directly to project records.'
  }, {
    name: 'Handover Packs',
    icon: Layers,
    desc: 'One-click generation of complete project documentation.'
  }];
  return <section className="bg-dashboard-bg py-16 md:py-24 border-b border-dashboard-border" data-id="element-243">
      <Container data-id="element-244">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-245">
          <h2 className="text-4xl font-black tracking-tight text-dashboard-text sm:text-5xl mb-6" data-id="element-246">
            The Systems Costing You{' '}
            <span className="text-tech-blue" data-id="element-247">The Most Time</span>
          </h2>
          <p className="text-lg text-dashboard-muted leading-relaxed" data-id="element-248">
            We don't rip and replace. We connect what you already
            own—SharePoint, Procore, Aconex—so they actually talk to each other.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-249">
          {systems.map((system, index) => <motion.div key={system.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.5
        }} className="bg-dashboard-surface rounded-lg p-6 border border-dashboard-border hover:border-tech-blue/50 transition-colors" data-id="element-250">
              <div className="flex items-center gap-3 mb-4" data-id="element-251">
                <div className="h-12 w-12 rounded-lg bg-tech-blue/10 border border-tech-blue/20 flex items-center justify-center" data-id="element-252">
                  <system.icon className="h-6 w-6 text-tech-blue" data-id="element-253" />
                </div>
                <h3 className="text-lg font-bold text-dashboard-text" data-id="element-254">
                  {system.name}
                </h3>
              </div>
              <p className="text-sm text-dashboard-muted leading-relaxed" data-id="element-255">
                {system.desc}
              </p>
            </motion.div>)}

          {/* Plus More card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.25,
          duration: 0.5
        }} className="bg-tech-blue/5 rounded-lg p-6 border border-tech-blue/20" data-id="element-256">
            <div className="flex items-center gap-3 mb-4" data-id="element-257">
              <div className="h-12 w-12 rounded-lg bg-tech-blue flex items-center justify-center" data-id="element-258">
                <ArrowRight className="h-6 w-6 text-white" data-id="element-259" />
              </div>
              <h3 className="text-lg font-bold text-dashboard-text" data-id="element-260">
                Plus More
              </h3>
            </div>
            <p className="text-sm text-dashboard-muted leading-relaxed mb-4" data-id="element-261">
              Timesheets, variations, procurement, resource management—we fix
              the systems slowing you down.
            </p>
          </motion.div>
        </div>

        {/* Trust reinforcement */}
        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} data-id="element-262">
          <p className="text-sm text-dashboard-muted" data-id="element-263">
            Works inside your Microsoft environment • No new software required
          </p>
        </motion.div>
      </Container>
    </section>;
}